import { Injectable } from '@angular/core';
import { Admin } from '@wb/core/interfaces/admin';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsGQL extends Query<UserSettingsResponse> {
  document = gql(`
    query userSettings($uid: String!) {
      userSettings(
        uid: $uid
      ) {
        code
        success
        message
        setting {
          key
          value
        }
      }
    }
  `);
}

export interface UserSettingsResponse {
  userSettings: {
    code: string;
    success: boolean;
    message: string;
    setting: [UserSetting];
  };
}

export interface UserSetting {
  key: string;
  value: string;
}

export interface UserWidgetsResponse {
  userWidgets: {
    code: string;
    success: boolean;
    message: string;
    userWidgets: UserWidgetResponse[];
  };
}

export interface UserWidgetResponse {
  uid: string;
  userWidgetUid: string;
  parameters: string;
  name: string;
  description: string;
  url: string;
  type: string;
  order: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserWidgets extends Query<UserWidgetsResponse> {
  document = gql(`
    query userWidgets ($uid: String!) {
      userWidgets(uid: $uid) {
        code
        message
        success
        userWidgets {
          uid
          userWidgetUid
          parameters
          name
          description
          url
          type
          order
        }
      }
    }
  `);
}

export interface AdminVersionResponse {
  adminVersion: {
    code: string;
    success: boolean;
    message: string;
    version: string;
  };
}

export interface AdminVersionVariables {
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class AdminVersionGQL extends Query<AdminVersionResponse, AdminVersionVariables> {
  document = gql(`
    query adminVersion ($email: String!) {
      adminVersion(email: $email) {
        code
        message
        success
        version
      }
    }
  `);
}

export interface LoginAdminV1Response {
  loginAdminV1: {
    code: string;
    success: boolean;
    message: string;
    admin: Admin;
  };
}

export interface LoginAdminV1Variables {
  email: string;
  password: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginAdminV1GQL extends Query<LoginAdminV1Response, LoginAdminV1Variables> {
  document = gql(`
    query loginAdminV1 ($email: String!, $password: String!) {
      loginAdminV1(email: $email, password: $password) {
        code
        message
        success
        admin {
          first_name
          last_name
          email
          phone_number
          settings
          uid
          token
          status
          image
          accountUid
          privilege
          image_key
          last_login
        }
      }
    }
  `);
}
